(function () {
    document.addEventListener("DOMContentLoaded", function () {

        if (window.location.pathname.includes("/products/")) {
            initSection({
                holderId: "pp-points-holder",
                sectionName: "pp-points",
                containerId: "pp-points-container",
                afterInject: removeNewYorkProductPoint,
            });          
        }

        if (window.location.pathname.includes("/cart")) {
            initSection({
                holderId: "cart-page-points-holder",
                sectionName: "cart-page-points",
                containerId: "cart-page-points-container"
            });
   
        }
    });

    /* -------------------------------------------
       GENERIC LOADER
    --------------------------------------------*/

     function initSection({
        holderId,
        sectionName,
        containerId,
        afterInject
    }) {
        let loaded = false;

        function checkInitValue() {
            const initValue = sessionStorage.getItem("initValue");

            if ((initValue === "111D" || initValue === "110wacD") && !loaded) {
                loaded = true;

                fetch(window.location.pathname + "?sections=" + sectionName)
                    .then((res) => res.json())
                    .then((data) => {
                        if (!data[sectionName]) return;

                        const holder = document.getElementById(holderId);
                        if (!holder) return;

                        holder.innerHTML = data[sectionName];

                        const block = document.getElementById(containerId);

                        if (block) block.style.display = "block";

                        if (typeof afterInject === "function") {
                            afterInject();
                        }
                    });
            } else if (initValue === null) {
                setTimeout(checkInitValue, 100);
            }
        }

        checkInitValue();
    }
})();

function watchDOM(callback) {
    const observer = new MutationObserver(function () {
        callback();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

let cartTimerInterval;

function initCartReservedTimer() {
    if (cartTimerInterval) clearInterval(cartTimerInterval);

    const container = document.getElementById("cart-reserved-container");
    const timerEl = document.getElementById("cart-reserved-timer");

    if (!container || !timerEl) return;

    const minutes = parseInt(container.dataset.minutes || "9", 10);
    let countdown = minutes * 60;

    function updateTimer() {
        const m = Math.floor(countdown / 60);
        const s = countdown % 60;

        timerEl.textContent = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;

        if (countdown > 0) {
            countdown--;
        } else {
            clearInterval(cartTimerInterval);
            container.style.display = "none";
        }
    }

    updateTimer();
    cartTimerInterval = setInterval(updateTimer, 1000);
}

function initAnnouncementBar() {

  const container = document.getElementById("announcement-bar-container");

  if (!container) return;

  const items = container.querySelectorAll(".custom-announcement-bar__text");

  if (items.length <= 1) return;

  let current = 0;
  let startX = 0;
  let endX = 0;

  function showSlide(index) {

    items.forEach((el) => {
      el.classList.remove("is-active");
      el.style.display = "none";
    });

    items[index].classList.add("is-active");
    items[index].style.display = "block";
  }

  function nextSlide() {
    current = (current + 1) % items.length;
    showSlide(current);
  }

  function prevSlide() {
    current = (current - 1 + items.length) % items.length;
    showSlide(current);
  }

  showSlide(current);

  const autoplay = container.querySelector(".custom-announcement-bar__carousel");

  if (autoplay && autoplay.dataset.autoplay) {

    const speed = parseInt(autoplay.dataset.autoplay, 10) * 1000;

    setInterval(nextSlide, speed);
  }

  /* -----------------------------
     TOUCH / DRAG SUPPORT
  ----------------------------- */

  container.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  container.addEventListener("touchend", (e) => {

    endX = e.changedTouches[0].clientX;

    handleSwipe();
  });

  container.addEventListener("mousedown", (e) => {
    startX = e.clientX;
  });

  container.addEventListener("mouseup", (e) => {

    endX = e.clientX;

    handleSwipe();
  });

  function handleSwipe() {

    const threshold = 50;

    if (startX - endX > threshold) {
      nextSlide();
    }

    if (endX - startX > threshold) {
      prevSlide();
    }
  }
}

function initUGCReviewsSlider() {

  const slider = document.querySelector('.ugc-reviews-swiper');

  if (!slider) return;

  const jsonEl = document.getElementById('ugc-reviews-json');

  if (!jsonEl) return;

  let reviews = [];

  try {

    reviews = JSON.parse(
  jsonEl.innerHTML.trim()
);

    // reviews = JSON.parse(
    //   jsonEl.textContent
    // );

  } catch (e) {

    console.error('Invalid reviews JSON', e);

    return;
  }

  const wrapper = document.getElementById('ugc-reviews-wrapper');

  if (!wrapper) return;

  wrapper.innerHTML = '';

  reviews.forEach((review) => {

    const slide = document.createElement('div');

    slide.className = 'swiper-slide';

    slide.innerHTML = `
<div class="ugc-review-card">
   <img
      src="${review.image}"
      alt="${review.name}"
      loading="lazy"
      class="ugc-review-image"
      >

  <div class="ugc-card-content">
   <div class="ugc-review-card__text">
      ${review.text}
   </div>
   <div class="ugc-review-card__footer">
      <div class="ugc-review-rating">
        <div class="ugc-review-stars">
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
        </div>
         <div class="ugc-review-verified">
            Verified
         </div>
      </div>
      <div class="ugc-review-name">
         ${review.name}
      </div>
   </div>
  </div>

</div>
    `;

    wrapper.appendChild(slide);
  });

  new Swiper('.ugc-reviews-swiper', {
    loop: true,
    speed: 600,
    spaceBetween: 24,
    grabCursor: true,

    navigation: {
      nextEl: '.ugc-reviews-next',
      prevEl: '.ugc-reviews-prev'
    },

    breakpoints: {
      0: {
         slidesPerView: 1.25,
         centeredSlides: false
      },

      768: {
        slidesPerView: 2
      },

      1024: {
        slidesPerView: 4
      }
    }
  });
}

// function initAnnouncementBar() {

//   const container = document.getElementById("announcement-bar-container");

//   if (!container) return;

//   const items = container.querySelectorAll(".custom-announcement-bar__text");

//   if (items.length <= 1) return;

//   let current = 0;

//   function showSlide(index) {

//     items.forEach((el) => {
//       el.classList.remove("is-active");
//       el.style.display = "none";
//     });

//     items[index].classList.add("is-active");
//     items[index].style.display = "block";
//   }

//   function nextSlide() {
//     current = (current + 1) % items.length;
//     showSlide(current);
//   }

//   function prevSlide() {
//     current = (current - 1 + items.length) % items.length;
//     showSlide(current);
//   }

//   const nextBtn = document.getElementById("announcement-next");
//   const prevBtn = document.getElementById("announcement-prev");

//   if (nextBtn) {
//     nextBtn.addEventListener("click", nextSlide);
//   }

//   if (prevBtn) {
//     prevBtn.addEventListener("click", prevSlide);
//   }

//   showSlide(current);

//   const autoplay = container.querySelector(".custom-announcement-bar__carousel");

//   if (autoplay && autoplay.dataset.autoplay) {

//     const speed = parseInt(autoplay.dataset.autoplay, 10) * 1000;

//     setInterval(nextSlide, speed);
//   }
// }


function removeNewYorkProductPoint() {
    const state = sessionStorage.getItem("state");

    if (state === "New York" || state === "NY") {
        document
            .querySelector(
                "#pp-points-container .product-page-points-wrapper-text:nth-of-type(2)"
            )
            ?.remove();
    }
}